export const loanConfig = {
    maxLoanFilterDateRangeInMonths: 12,
};

export const DASHBOARD_DIV_ID = 'dashboard-wrapper';

export const serviceErrorCodes = {
    TOPUP_TRIGGERED: 1033,
    USER_CANCELLED: 1012,
    NO_ACTIVE_LOAN: 3004,
    APPLICATION_NOT_APPROVED: 3005,
};
